//region block: pre-declaration
//endregion
function isJodaDateTimeException(_this__u8e3s4) {
  return hasJsExceptionName(_this__u8e3s4, 'DateTimeException');
}
function isJodaDateTimeParseException(_this__u8e3s4) {
  return hasJsExceptionName(_this__u8e3s4, 'DateTimeParseException');
}
function isJodaArithmeticException(_this__u8e3s4) {
  return hasJsExceptionName(_this__u8e3s4, 'ArithmeticException');
}
function hasJsExceptionName(_this__u8e3s4, name) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.name == name;
}
//region block: exports
export {
  isJodaArithmeticException as isJodaArithmeticExceptionwen50fdrku5h,
  isJodaDateTimeException as isJodaDateTimeException2l3lhdyy3jadv,
  isJodaDateTimeParseException as isJodaDateTimeParseException1w7urgwwcr7j6,
};
//endregion

//# sourceMappingURL=JSJodaExceptions.mjs.map
